const StepPedagogicalApproachComponent = {
    template: require('./stepPedagogicalApproachView.html'),
    controller: () => {
    },
};

export default StepPedagogicalApproachComponent;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepPedagogicalApproach/stepPedagogicalApproachComponent.js